export default "__VITE_ASSET__UOHq3ij9__"